import digitalData from '~/common/services/data-layer-service';

export function dataLayerPushDownloadBrochure(model: string) {
  digitalData.push({
    event: '_formNavigate',
    form: {
      name: 'download a brochure',
      stage: 'submitted',
      details: {
        vehicleSelected: [
          {
            make: 'Subaru',
            model,
          },
        ],
      },
    },
  });
}
